import { useState } from "react"
import { Input } from "../common/input/Input"

type Props = {
  termsConditions: boolean
  addTermsConditions: Function
  register: any
  errors: any
  name: string
  setValue: Function
}

const TermsAndConditions: React.FC<Props> = ({
  termsConditions,
  addTermsConditions,
  register,
  name,
  setValue,
  errors,
}) => {
  const [checked, setChecked] = useState(termsConditions)

  return (
    <div className="terms-and-conditions" id="terms">
      <div className="input-label">
        <div className=" checkbox-terms">
          <Input
            type="checkbox"
            value="checked"
            name={name}
            register={register}
            rules={{
              required: true,
            }}
            errors={errors}
            onClick={() => {
              setValue("termsConditions", !checked)
              setChecked(!checked)
              addTermsConditions(!checked)
            }}
          />
        </div>
      </div>

      <p className="terms-text">
        I have read the{" "}
        <a
          className="underlined"
          href="https://www.lookers.co.uk/privacy-notice"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>{" "}
        and accept the{" "}
        <a
          className="underlined"
          href="https://www.lookers.co.uk/-/media/Lookers-Group/Group/PDFs/ClickSellterms-221021.pdf?la=en&rev=a017beacfb3d4838839ef2377f8a7daf&hash=44FD5F3B71A1051C0E69F02E2A4BD64D4EEDE8C1"
        >
          Terms
        </a>
        . I understand Lookers will get in touch about my valuation.
      </p>
    </div>
  )
}

export default TermsAndConditions
